<!-- VizbiPlus public events; compiled from legacy/Plus/Plus Events and timeline pages -->

<template>
  <h4>VizbiPlus Events</h4>
  <p>
    The VizbiPlus project presented its animations at a series of public events across
    Australia:
  </p>
  <ul>
    <li v-for="event in events" :key="event.date + event.title">
      <strong>{{ event.date }}</strong> &mdash;
      <router-link v-if="event.link" :to="event.link">{{ event.title }}</router-link>
      <template v-else>{{ event.title }}</template>, {{ event.venue }}
      <span v-if="event.vivid" class="vivid">(with Vivid Ideas)</span>
    </li>
  </ul>
  <p>
    For the full series of VIZBI Showcase events, including those beyond VizbiPlus, see
    <router-link to="/Showcases">VIZBI Showcases</router-link>.
  </p>
</template>

<script setup>
const events = [
  {date: "30 May 2013", title: "'Ten Commandments: Connect with Science'",
    venue: "Museum of Contemporary Art, Sydney", link: "/2013/Showcase", vivid: true},
  {date: "29 May 2014", title: "'Making Science Beautiful'",
    venue: "Museum of Contemporary Art, Sydney", link: "/2014/Showcase", vivid: true},
  {date: "May 2014", title: "VizbiPlus animations on the Big Screen",
    venue: "Federation Square, Melbourne", link: "/2014/Showcase/FederationSquare"},
  {date: "4 February 2015", title: "VizbiPlus Animation Premiere",
    venue: "CSIRO Discovery Centre, Canberra", link: "/2015/Showcase"},
  {date: "7 June 2015", title: "'Science Reimagined'",
    venue: "Charles Perkins Centre, University of Sydney", link: "/2015/Showcase", vivid: true},
  {date: "7 June 2016", title: "'Visualising the Future of Biomedicine'",
    venue: "The Kinghorn Cancer Centre, Sydney", link: "/2016/Showcase", vivid: true},
  {date: "29 May & 12 June 2017",
    title: "VizbiPlus Exhibit & 'Bridging Science with Art, Design & Animation'",
    venue: "Spunky Bruiser Store & Museum of Contemporary Art, Sydney", link: "/2017/Showcase",
    vivid: true}
];
</script>

<style scoped>
ul {
  list-style-type: square;
}
li {
  margin-bottom: 0.5rem;
}
.vivid {
  color: var(--subtitle-color);
  font-size: 0.9rem;
}
</style>
